import moment from 'moment';

const baseUrlImage = 'https://cdn03.supersoccer.tv/v4/images';

export const bgImageField = `${baseUrlImage}/match.jpg`;

export const bellIcon = `${baseUrlImage}/bell.png`;

export const crossIcon = `${baseUrlImage}/cross.png`;

export const loop = `${baseUrlImage}/loop.png`;

export const synopsis = `${baseUrlImage}/synopsis.png`;

export const playActiveIcon = `${baseUrlImage}/playActive.png`;

export const calendar = `${baseUrlImage}/calendar.png`;

export const remindme = `${baseUrlImage}/remindme.png`;

export const favoriteIcon = `${baseUrlImage}/star-fill.png`;

export const otherMenu = `${baseUrlImage}/other-menu.png`;

export const sstvlogo = `${baseUrlImage}/sstv-logo.png`;

export const defaultImg = `${baseUrlImage}/match-league-default.jpg`;

export const getBackgroundImage = LEAGUE_NAME => {
  return `${baseUrlImage}/match-league-${LEAGUE_NAME}.jpg?img=${moment().format(
    'DD-MM-YYYY'
  )}`;
};

export const getClubImage = TEAM_ID => {
  return `${baseUrlImage}/clubs/${TEAM_ID}.png?img=${moment().format(
    'DD-MM-YYYY'
  )}`;
};
